import React from "react";

const ShowOff: React.FC<{ color?: string }> = ({ color = "#121C2D" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
  >
    <path
      d="M1.5 10s3.5-5.5 8.5-5.5c2.2 0 4.08.83 5.58 1.94M18.5 10s-3.5 5.5-8.5 5.5c-2.2 0-4.08-.83-5.58-1.94"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="none"
    />
    <circle
      cx="10"
      cy="10"
      r="2.75"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
    />

    <path
      d="M3 17 17 3"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default ShowOff;
